import React, { useLayoutEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { Button, ButtonToolbar } from 'reactstrap';
import { Link } from 'react-router-dom';
import { HOLIDAY_PATH, NEW_HOLIDAY_PATH } from '../../../../config/paths';
import { clearHolidays, getHolidays, postExportHolidaysExcel } from '../../../../actions';
import { HOLIDAY_COLUMNS } from '../../../../config/columns';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Table from '../../../common/Table';
import ImportHolidaysModal from './ImportHolidaysModal';

export const Holidays = ({
  dispatchGetHolidays,
  dispatchClearHolidays,
  loading,
  holidays,
  breadcrumbs,
  dispatchGenerateHolidaysExcel
}) => {
  const [showImportModal, setShowImportModal] = useState(false);
  const [tableKey, setTableKey] = useState(0);

  useLayoutEffect(() => () => dispatchClearHolidays(), []);

  const refreshTable = () => setTableKey((prev) => prev + 1);

  const data = holidays.get('content') || [];
  const pages = holidays.get('totalPages') || null;
  const defaultPageSize = holidays.get('size') || DEFAULT_PAGE_SIZE;

  const toolbar = (
    <ButtonToolbar className="pull-right">
      <Button
        color="success"
        className="mr-2"
        onClick={() => dispatchGenerateHolidaysExcel()}
      >
        <i className="fa fa-file-excel-o mr-2" />
        Generar Plantilla
      </Button>
      <Button
        color="secondary"
        className="mr-2"
        onClick={() => setShowImportModal(true)}
      >
        <i className="fa fa-upload mr-2" />
        Importar
      </Button>
      <Link className="btn btn-primary" to={NEW_HOLIDAY_PATH}>
        <i className="fa fa-plus-circle mr-2" />
        Crear
      </Link>
    </ButtonToolbar>
  );

  const content = (
    <>
      <ImportHolidaysModal
        show={showImportModal}
        onClose={() => setShowImportModal(false)}
        onImported={refreshTable}
      />
      <Table
        key={tableKey}
        columns={HOLIDAY_COLUMNS}
        data={data}
        pages={pages}
        defaultPageSize={defaultPageSize}
        filterable
        fetchData={dispatchGetHolidays}
        modelPath={HOLIDAY_PATH}
        loading={loading}
        navigateToModelOnRowClick
      />
    </>
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Feriados"
      toolbar={toolbar}
      content={content}
    />
  );
};

Holidays.propTypes = {
  dispatchGetHolidays: PropTypes.func.isRequired,
  dispatchClearHolidays: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  holidays: PropTypes.instanceOf(Immutable.Map),
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGenerateHolidaysExcel: PropTypes.func.isRequired
};

Holidays.defaultProps = {
  loading: false,
  holidays: null,
};

const mapStateToProps = ({ HumanResourcesUnit }) => ({
  breadcrumbs: [
    ...HumanResourcesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Feriados',
      href: HOLIDAY_PATH,
    },
  ],
  holidays: HumanResourcesUnit.Holiday.getIn(['all', 'content']),
  loading: HumanResourcesUnit.Holiday.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetHolidays: getHolidays,
  dispatchClearHolidays: clearHolidays,
  dispatchGenerateHolidaysExcel: postExportHolidaysExcel
};

export default connect(mapStateToProps, mapDispatchToProps)(Holidays);